import { createFileRoute } from '@tanstack/react-router';
import { AchievementsView } from '@/components/AchievementsView';

export const Route = createFileRoute('/_authenticated/achievements')({
  component: AchievementsView,
});

